import { Component, OnInit } from '@angular/core';
import { DataPointDataType, DynamicComponentBase, IDynamicComponentConfig, ValidationRuleType } from '../../../dynamic-component';

@Component({
  selector: 'app-d-con-string-config',
  templateUrl: './d-con-string-config.component.html',
  styles: []
})
export class DConStringConfigComponent extends DynamicComponentBase implements OnInit {
  static KEY = 'd-con-string-config';
  dataType = DataPointDataType;
  constructor() {
    super();
  }
  ngOnInit() {
    /** 数据类型设置 */
    this.config.dataType = this.dataType.String;
  }
  configChange(config: IDynamicComponentConfig) {}
}
